import React, { useEffect } from "react";
import {
  FounderCredentialsSection,
  FounderHeroSection,
  FounderNoteSection,
  FounderQuoteSection,
} from "../../components/founder";
import founderData from "../../data/founderData.json";
import "./founder.css";

export default function Founder() {
  return (
    <div className="founder-page">
      <FounderHeroSection data={founderData.hero} />
      <FounderNoteSection data={founderData.note} />
      <FounderQuoteSection data={founderData.quote} />
      <FounderCredentialsSection
        credentials={founderData.credentials}
        profile={founderData.profile}
      />
    </div>
  );
}
